import PropTypes from "prop-types";

import useUserContentUIContext from "@/view/utils/useUserContentUIContext";
import VideoEmbed from "@/view/VideoEmbed";
import { innerContainerCss, figureCss, captionCss } from "./VideoBody.style";

const propTypes = {
  content: PropTypes.object,
  showVeil: PropTypes.bool,
  isVideoPresentModeActive: PropTypes.bool,
  user: PropTypes.object,
};

const VideoBody = ({ content, showVeil, isVideoPresentModeActive, user }) => {
  const { uiType } = useUserContentUIContext();
  return (
    <div css={innerContainerCss(uiType)}>
      <figure css={figureCss}>
        <VideoEmbed
          contentId={content.id}
          src={content.data?.url}
          user={user}
          showVeil={showVeil}
        />
        {isVideoPresentModeActive ? null : (
          <figcaption css={captionCss}>
            {content.data?.link_description}
          </figcaption>
        )}
      </figure>
    </div>
  );
};

VideoBody.propTypes = propTypes;

export default VideoBody;
